define({
    pfxControl: 'c-',
    pfxOption: 'opt-',
    pfxBinding: 'bind-',
    pfxContextValue: '.',
    filterSeparator: '|'
});
